import React, { useState } from "react";
import { Form } from "react-bootstrap";
import { DisclaimerModal } from "./Components/DiscliamerModal";
import { SelectComponent } from "./Components/Select";
import { pricingOptions, finOptions } from "./utils";

const FinancingDetails = ({
  continueStepEvent,
  backStepEvent,
  handleChange,
  formObj,
  isPreview,
  comboResponse,
}) => {
  const detailObject = formObj.fundDetails;

  const [show, setShow] = useState(false);
  const handleClose = () => setShow((prvstate) => !prvstate);

  const continueFormEvent = (e) => {
    e.preventDefault();
    continueStepEvent("fundDetails");
  };

  return (
    <div className="tab-pane" role="tabpanel" id="step5">
      <Form onSubmit={(e) => continueFormEvent(e)}>
        <div className="row">
          <h4 className="my-3">Financing Details</h4>

          <div className="col-md-4">
            <div className="form-group">
              <label>Financing Option *</label>
              <Form.Select
                value={detailObject.financing_option.value}
                className="form-control"
                required
                disabled={isPreview ? true : false}
                placeholder="Select Financing Option"
                onChange={(e) =>
                  handleChange(e, "fundDetails", "financing_option")
                }
              >
                <option value="">Select Financing Option</option>
                {comboResponse?.Financing_option.map((item, index) => {
                  return (
                    <option key={index} value={item.key}>
                      {item.value}
                    </option>
                  );
                })}
              </Form.Select>
            </div>
          </div>

          <div className="col-md-4">
            <label>Pricing Option *</label>
            <Form.Select
              value={detailObject.pricing_option.value}
              className="form-control"
              type="number"
              required
              disabled={isPreview ? true : false}
              placeholder="Select Pricing Option"
              onChange={(e) => handleChange(e, "fundDetails", "pricing_option")}
            >
              <option value="">Select Pricing Option</option>
              {comboResponse?.Pricing_option.map((item, index) => {
                return (
                  <option key={index} value={item.key}>
                    {item.value}
                  </option>
                );
              })}
            </Form.Select>
          </div>
        </div>

        {/* To View Final Page Details */}
        {!isPreview ? (
          <ul className="list-inline pull-right">
            <li>
              <button
                type="button"
                className="default-btn prev-step"
                onClick={backStepEvent}
              >
                Back
              </button>
            </li>
            <li></li>
            <li>
              <button type="submit" className="default-btn next-step">
                Continue
              </button>
            </li>
          </ul>
        ) : (
          ""
        )}
      </Form>
    </div>
  );
};

export default FinancingDetails;
